import { render, staticRenderFns } from "./input-choice.vue?vue&type=template&id=753bf132&"
import script from "./input-choice.vue?vue&type=script&lang=js&"
export * from "./input-choice.vue?vue&type=script&lang=js&"
import style0 from "./input-choice.vue?vue&type=style&index=0&id=753bf132&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports